import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {take, takeUntil} from 'rxjs/operators';
import {TaskManagerService} from '@features/task-manager/services/task-manager.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {CommandService} from '@core/services/command.service';
import {Subject} from 'rxjs';
import {TaskManagerState} from '@features/task-manager/store/task-manager.reducer';
import {select, Store} from '@ngrx/store';
import {getTaskViewUpdateInfo} from '@features/task-manager/store/task-manager.selector';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import { getUserInfo } from '@shared/store/selectors/security.selector';
import { ChatEditorOutput } from '@shared/models/chat-editor.model';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'particle-task-description',
  templateUrl: './task-description.component.html',
  styleUrls: ['./task-description.component.scss']
})
export class TaskDescriptionComponent implements OnInit, OnDestroy {
  id = 'task-description';
  @Input() card: any;
  @Input() board: any;
  @Input() data: any;
  @Input() taskMenuItemsMapper: any = {};
  @Output() actionEvent$: EventEmitter<any> = new EventEmitter();
  @Input() dynamicData: any;
  unSubscribe = new Subject<void>();
  api = 'TaskManagerApi';
  isDescriptionEditing = false;
  hasPermission = true;
  textEditorChatText = '';
  cardId: string;
  scope: number;
  currentUser: any;
  response: any;

  constructor(private taskManagerService: TaskManagerService,
    private snackBarService: SnackBarService,
    private taskManagerStore: Store<TaskManagerState>,
    protected commandService: CommandService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private securityStore: Store<SecurityState>) {
  }

  ngOnInit(): void {

    this.taskManagerService.taskApi = this.data.input.parameters?.taskApi ?? 'TaskManagerApi';
    if (this.data.input.card) {
      this.card = this.data.input.card;
      if (this.card.description) {
        this.textEditorChatText = this.card.description;
      }
    }
    if (this.data.input.board) {
      this.board = this.data.input.board;
    }
    this.securityStore.pipe(select(getUserInfo)).pipe(takeUntil(this.unSubscribe)).subscribe(currentUser => {
      this.currentUser = currentUser;
    });
    this.hasPermission = this.card && this.card.hasPermission;
    this.changePermissionForSupportTeamMember(this.currentUser);
    this.subscribeToInvalidatorListener();
  }

  private subscribeToInvalidatorListener() {
    this.taskManagerStore.pipe(select(getTaskViewUpdateInfo)).pipe(takeUntil(this.unSubscribe)).subscribe(updatedTaskViewInfo => {
      if (updatedTaskViewInfo && updatedTaskViewInfo.card && updatedTaskViewInfo.card.id === this.card.id) {
        this.card = updatedTaskViewInfo.card;
      }
    });
  }


  private invalidateTaskView(card: any) {
    this.data.input.taskInvalidator.next({card: card, sourceViewId: this.id});
  }


  private focusDescriptionBox() {
    const element = document.getElementById('task-description-box');
    if (element) {
      element.focus();
    }
  }

  startDescriptionEdit($event: MouseEvent) {
    if (!this.hasPermission || this.isDescriptionEditing) {
      return;
    }
    this.isDescriptionEditing = true;
    //this.resetTitleEditing();
    setTimeout(() => {
      this.focusDescriptionBox();
    }, 100);
  }

  resetDescriptionEditing() {
    this.isDescriptionEditing = false;
  }
  
  

  onSaveDescriptionChange(chatEditorOutput: ChatEditorOutput) {
    this.card.description = chatEditorOutput.chatText;
    this.textEditorChatText = chatEditorOutput.chatText;
    this.resetDescriptionEditing();
    
    this.updateDetails();
  }

  private updateDetails() {
    this.fuseSplashScreenService.show();
    this.card.taskStartDate = this.card.startDate;
    const updateTaskCommand = this.taskManagerService.getAddOrUpdateTaskCommand(this.board, this.card);
    this.commandService.executePlatformCommand(updateTaskCommand).pipe(take(1)).subscribe(response => {
      // this.resetTitleEditing();
      this.invalidateTaskView(this.card);
      this.resetDescriptionEditing();
      this.fuseSplashScreenService.hide();
    }, err => {
      this.snackBarService.showError('Update failed!');
    });
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }

  handlePasteEvent($event: ClipboardEvent) {
    $event.preventDefault();
    const tempDivElement = document.createElement('div');
    const pasteValue = ($event.clipboardData).getData('text');
    // Set the HTML content with the given value
    tempDivElement.innerHTML = pasteValue;
    // Retrieve the text property of the element
    const plainText = tempDivElement.textContent || tempDivElement.innerText || '';
    const selection = window.getSelection();
    if (!selection.rangeCount) {
      return;
    }
    selection.deleteFromDocument();
    selection.getRangeAt(0).insertNode(document.createTextNode(plainText));
  }

  private isMemberOfSupportTeam(user) {
    return user.companyId.toLowerCase() === 'orbitaxsupport';
  }
  private changePermissionForSupportTeamMember(user) {
    if (this.board?.id == "orbitax_support" && this.isMemberOfSupportTeam(user)) {
      this.hasPermission = false;
    }
  }
}